import { FormTemplate } from "components/modal/templates";
import { formatDateForDocumentTag } from "helpers/date";
import moment from "moment";
import React from "react";
import { createInvoice } from "sources/books/registries";
import { config, initialState } from "./config";

class CreateRegistryInvoiceForm extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    render = () => this.renderBody();

    sendRequest = (stateData = this.state) =>
        createInvoice({
            id: Number(this.props.id),
            classificationTypeId: stateData.classificationType,
            manualValues: {
                documentDate: formatDateForDocumentTag(stateData.documentDate),
            },
        });

    renderBodyInner = () => (
        <>
            {this.renderDateField(this.props.config.documentDate)}
            {this.renderSelect(this.props.config.classificationType)}
        </>
    );

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Создать счет" />;
    };
}

export default function ConfiguredCreateRegistryInvoiceForm(props) {
    const formInitialState = {
        ...initialState,
        documentDate: moment().format("YYYY-MM-DD"),
    };

    return <CreateRegistryInvoiceForm {...props} config={config} initialState={formInitialState} />;
}
